import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { HeaderDrawerMain } from "components";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { sortItems } from "./constants";
import { SaveParams } from "utils";

export const SortContentDrawer = ({ closeDrawer, anchor }) => {
  const [value, setValue] = useState("");
  const location = useLocation();
  const navigator = useNavigate();
  const info = location?.state;

  useEffect(() => {
    if (info?.valueSort) {
      setValue(info?.valueSort);
    }
  }, [info?.valueSort]);

  const handleChange = (item) => {
    setValue(item?.value);
    closeDrawer(anchor);
    const params = {
      ...info,
    };
    if (item?.sortType) params.sortType = item?.sortType;
    if (item?.orderType) params.orderType = item?.orderType;
    if (item?.value) params.valueSort = item?.value;

    SaveParams(location?.pathname, navigator, params);
  };

  return (
    <div className="sort-content-drawer-donors">
      <HeaderDrawerMain title="Sort By Amount" closeModal={closeDrawer} />
      <div className="sort-content-drawer-donors-body">
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            value={info?.sortValue}
          >
            {sortItems?.map((item, index) => (
              <FormControlLabel
                key={index}
                className={value === item?.value ? "sort-by-active" : ""}
                onClick={() => handleChange(item)}
                value={item?.value}
                checked={value === item?.value}
                control={<Radio />}
                label={item?.label}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
};
